import { ready, onShopifySectionLoad } from '../utils/readyinit';
import initQuantityInputs from '../components/quantityInputs';
import initProductVariants from '../components/product-variants';
import initShadeVariants from '../components/shade-variants';
import initRelatedProducts from '../sections/product/related-products';
import initProductStickyAtc, { initAppBlockAtc } from '../components/product-sticky-atc';
import initKlaviyoBis from '../sections/product/klaviyo-bis';
import initMMM from '../components/mmm';

ready(() => {
  initQuantityInputs();
  initProductVariants();
  initShadeVariants();
  initRelatedProducts();
  initProductStickyAtc();
  initAppBlockAtc();
  initKlaviyoBis();
  initMMM();
});

onShopifySectionLoad(() => {
  initRelatedProducts();
});
